import { BASE_URL } from "@/constants/endpoints";
import { PermissionCode } from "@/constants/permissions";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { AxiosInstance } from "axios";

let actionsApiPromise: Promise<AxiosInstance> | null = null;

const getActionsApi = async (): Promise<AxiosInstance | null> => {
  if (actionsApiPromise) return actionsApiPromise;
  actionsApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return actionsApiPromise;
};

// ------------------------------------------------------------
// Endpoints
// ------------------------------------------------------------
const BASE_PATH = "/Acciones";

// ------------------------------------------------------------
// Tipos (mínimos) de Requests/Responses
// ------------------------------------------------------------
export interface BlockedAction {
  codigo: string;
  descripcion: string;
  bloqueada: boolean;
}

// ------------------------------------------------------------
// API
// ------------------------------------------------------------
// GET /Acciones/{codigoPermiso}/bloqueadas
export const getBlockedActions = async (
  codigoPermiso: PermissionCode,
): Promise<BlockedAction[] | undefined> => {
  const api = await getActionsApi();
  if (!api) return;

  const response = await api.get(`${BASE_PATH}/${codigoPermiso}/bloqueadas`);
  return response.data;
};
